// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ops-overview {
  width: 100%;
}

.ops-overview--loading,
.ops-overview--error {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 24px;
  border-radius: 12px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  color: #6b7280;
  font-size: 14px;
}

.ops-overview--error {
  color: #b91c1c;
}

.ops-overview--error button {
  margin-left: auto;
  padding: 6px 14px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  background: #f9fafb;
  cursor: pointer;
  font-size: 13px;
}

.ops-spin {
  animation: ops-spin 1.1s linear infinite;
}

@keyframes ops-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.ops-error-banner {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-radius: 10px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #b91c1c;
  font-size: 12.5px;
  margin-bottom: 14px;
}

.ops-error-banner button {
  margin-left: auto;
  padding: 5px 12px;
  border-radius: 7px;
  border: 1px solid #fecaca;
  background: #fff;
  cursor: pointer;
  font-size: 12px;
  color: #b91c1c;
  flex-shrink: 0;
}

.ops-panel-error {
  margin: -8px 0 0;
  font-size: 12px;
  color: #b91c1c;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  padding: 6px 10px;
}

/* auto-fit reflows into 1, 2, or 3 columns depending on width, so adding
   the Machine panel doesn't require a manual breakpoint change. */
.ops-overview__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(340px, 1fr));
  gap: 20px;
}

.ops-panel {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.ops-panel__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.ops-panel__title-group {
  display: flex;
  gap: 10px;
  align-items: flex-start;
}

.ops-panel__icon {
  width: 34px;
  height: 34px;
  border-radius: 9px;
  background: #eff4ff;
  color: #2563eb;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.ops-panel__title-group h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #111827;
}

.ops-panel__title-group p {
  margin: 2px 0 0;
  font-size: 12.5px;
  color: #6b7280;
}

.ops-panel__refresh {
  border: 1px solid #e5e7eb;
  background: #f9fafb;
  border-radius: 8px;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #4b5563;
}

.ops-stat-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

/* Used by MachinePanel: stacks pills vertically inside the narrower
   right-hand column next to the machine chip list. */
.ops-stat-row--stacked {
  flex-direction: column;
  align-items: stretch;
}

.ops-stat-pill {
  border-radius: 10px;
  padding: 8px 12px;
  background: #f9fafb;
  border: 1px solid #eef0f3;
  min-width: 96px;
}

.ops-stat-pill__value {
  display: block;
  font-size: 18px;
  font-weight: 700;
  color: #111827;
}

.ops-stat-pill__label {
  display: block;
  font-size: 11.5px;
  color: #6b7280;
  margin-top: 2px;
}

.ops-stat-pill--today {
  background: #eff4ff;
  border-color: #dbe6fe;
}

.ops-stat-pill--today .ops-stat-pill__value {
  color: #2563eb;
}

.ops-stat-pill--pending {
  background: #fff8eb;
  border-color: #fde8c2;
}

.ops-stat-pill--pending .ops-stat-pill__value {
  color: #d97706;
}

.ops-stat-pill--clickable {
  cursor: pointer;
  transition: transform 0.1s ease, box-shadow 0.1s ease;
}

.ops-stat-pill--clickable:hover,
.ops-stat-pill--clickable:focus-visible {
  box-shadow: 0 0 0 1px #d1d5db inset;
  transform: translateY(-1px);
  outline: none;
}

.ops-panel__chart {
  background: #fbfbfc;
  border: 1px solid #f1f2f4;
  border-radius: 12px;
  padding: 8px 4px 0;
}

.ops-panel__lists {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

.ops-panel__list-col h4 {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0 0 8px;
  font-size: 12.5px;
  font-weight: 600;
  color: #374151;
  text-transform: none;
}

.ops-panel__list-col ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.ops-empty {
  font-size: 12.5px;
  color: #9ca3af;
  margin: 0;
}

.ops-request-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 9px;
  background: #f9fafb;
  cursor: pointer;
  transition: background 0.12s ease;
}

.ops-request-row:hover,
.ops-request-row:focus-visible {
  background: #f1f3f5;
  outline: none;
}

.ops-request-row__dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex-shrink: 0;
}

.ops-request-row__dot--today {
  background: #2563eb;
}

.ops-request-row__dot--pending {
  background: #d97706;
}

.ops-request-row__main {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-width: 0;
}

.ops-request-row__name {
  font-size: 13px;
  font-weight: 500;
  color: #111827;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ops-request-row__meta {
  font-size: 11.5px;
  color: #6b7280;
}

.ops-request-row__chevron {
  color: #c7cbd1;
  flex-shrink: 0;
}

.ops-material-body {
  display: grid;
  grid-template-columns: 140px 1fr;
  gap: 14px;
  align-items: start;
}

@media (max-width: 640px) {
  .ops-material-body {
    grid-template-columns: 1fr;
  }
  .ops-panel__lists {
    grid-template-columns: 1fr;
  }
}

.ops-vendor-list h4 {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0 0 8px;
  font-size: 12.5px;
  font-weight: 600;
  color: #374151;
}

.ops-vendor-list ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 220px;
  overflow-y: auto;
}

.ops-vendor-chip {
  width: 100%;
  text-align: left;
  padding: 7px 10px;
  border-radius: 8px;
  border: 1px solid #eef0f3;
  background: #fff;
  font-size: 12.5px;
  color: #374151;
  cursor: pointer;
}

.ops-vendor-chip--active {
  background: #2563eb;
  border-color: #2563eb;
  color: #fff;
}

.ops-panel__chart--pie {
  padding-top: 4px;
}

.ops-panel__footer-link {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11.5px;
  color: #9ca3af;
  border-top: 1px solid #f1f2f4;
  padding-top: 12px;
}`, "",{"version":3,"sources":["webpack://./src/Components/Home/home.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;kEACkE;AAClE;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;qDACqD;AACrD;EACE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,qDAAqD;AACvD;;AAEA;;EAEE,mCAAmC;EACnC,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iCAAiC;AACnC;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,cAAc;EACd,6BAA6B;EAC7B,iBAAiB;AACnB","sourcesContent":[".ops-overview {\n  width: 100%;\n}\n\n.ops-overview--loading,\n.ops-overview--error {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 24px;\n  border-radius: 12px;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  color: #6b7280;\n  font-size: 14px;\n}\n\n.ops-overview--error {\n  color: #b91c1c;\n}\n\n.ops-overview--error button {\n  margin-left: auto;\n  padding: 6px 14px;\n  border-radius: 8px;\n  border: 1px solid #e5e7eb;\n  background: #f9fafb;\n  cursor: pointer;\n  font-size: 13px;\n}\n\n.ops-spin {\n  animation: ops-spin 1.1s linear infinite;\n}\n\n@keyframes ops-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.ops-error-banner {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 14px;\n  border-radius: 10px;\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  color: #b91c1c;\n  font-size: 12.5px;\n  margin-bottom: 14px;\n}\n\n.ops-error-banner button {\n  margin-left: auto;\n  padding: 5px 12px;\n  border-radius: 7px;\n  border: 1px solid #fecaca;\n  background: #fff;\n  cursor: pointer;\n  font-size: 12px;\n  color: #b91c1c;\n  flex-shrink: 0;\n}\n\n.ops-panel-error {\n  margin: -8px 0 0;\n  font-size: 12px;\n  color: #b91c1c;\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 8px;\n  padding: 6px 10px;\n}\n\n/* auto-fit reflows into 1, 2, or 3 columns depending on width, so adding\n   the Machine panel doesn't require a manual breakpoint change. */\n.ops-overview__grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(340px, 1fr));\n  gap: 20px;\n}\n\n.ops-panel {\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 14px;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.ops-panel__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n}\n\n.ops-panel__title-group {\n  display: flex;\n  gap: 10px;\n  align-items: flex-start;\n}\n\n.ops-panel__icon {\n  width: 34px;\n  height: 34px;\n  border-radius: 9px;\n  background: #eff4ff;\n  color: #2563eb;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.ops-panel__title-group h3 {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.ops-panel__title-group p {\n  margin: 2px 0 0;\n  font-size: 12.5px;\n  color: #6b7280;\n}\n\n.ops-panel__refresh {\n  border: 1px solid #e5e7eb;\n  background: #f9fafb;\n  border-radius: 8px;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #4b5563;\n}\n\n.ops-stat-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n/* Used by MachinePanel: stacks pills vertically inside the narrower\n   right-hand column next to the machine chip list. */\n.ops-stat-row--stacked {\n  flex-direction: column;\n  align-items: stretch;\n}\n\n.ops-stat-pill {\n  border-radius: 10px;\n  padding: 8px 12px;\n  background: #f9fafb;\n  border: 1px solid #eef0f3;\n  min-width: 96px;\n}\n\n.ops-stat-pill__value {\n  display: block;\n  font-size: 18px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.ops-stat-pill__label {\n  display: block;\n  font-size: 11.5px;\n  color: #6b7280;\n  margin-top: 2px;\n}\n\n.ops-stat-pill--today {\n  background: #eff4ff;\n  border-color: #dbe6fe;\n}\n\n.ops-stat-pill--today .ops-stat-pill__value {\n  color: #2563eb;\n}\n\n.ops-stat-pill--pending {\n  background: #fff8eb;\n  border-color: #fde8c2;\n}\n\n.ops-stat-pill--pending .ops-stat-pill__value {\n  color: #d97706;\n}\n\n.ops-stat-pill--clickable {\n  cursor: pointer;\n  transition: transform 0.1s ease, box-shadow 0.1s ease;\n}\n\n.ops-stat-pill--clickable:hover,\n.ops-stat-pill--clickable:focus-visible {\n  box-shadow: 0 0 0 1px #d1d5db inset;\n  transform: translateY(-1px);\n  outline: none;\n}\n\n.ops-panel__chart {\n  background: #fbfbfc;\n  border: 1px solid #f1f2f4;\n  border-radius: 12px;\n  padding: 8px 4px 0;\n}\n\n.ops-panel__lists {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px;\n}\n\n.ops-panel__list-col h4 {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin: 0 0 8px;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: #374151;\n  text-transform: none;\n}\n\n.ops-panel__list-col ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.ops-empty {\n  font-size: 12.5px;\n  color: #9ca3af;\n  margin: 0;\n}\n\n.ops-request-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 10px;\n  border-radius: 9px;\n  background: #f9fafb;\n  cursor: pointer;\n  transition: background 0.12s ease;\n}\n\n.ops-request-row:hover,\n.ops-request-row:focus-visible {\n  background: #f1f3f5;\n  outline: none;\n}\n\n.ops-request-row__dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.ops-request-row__dot--today {\n  background: #2563eb;\n}\n\n.ops-request-row__dot--pending {\n  background: #d97706;\n}\n\n.ops-request-row__main {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-width: 0;\n}\n\n.ops-request-row__name {\n  font-size: 13px;\n  font-weight: 500;\n  color: #111827;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ops-request-row__meta {\n  font-size: 11.5px;\n  color: #6b7280;\n}\n\n.ops-request-row__chevron {\n  color: #c7cbd1;\n  flex-shrink: 0;\n}\n\n.ops-material-body {\n  display: grid;\n  grid-template-columns: 140px 1fr;\n  gap: 14px;\n  align-items: start;\n}\n\n@media (max-width: 640px) {\n  .ops-material-body {\n    grid-template-columns: 1fr;\n  }\n  .ops-panel__lists {\n    grid-template-columns: 1fr;\n  }\n}\n\n.ops-vendor-list h4 {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin: 0 0 8px;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: #374151;\n}\n\n.ops-vendor-list ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  max-height: 220px;\n  overflow-y: auto;\n}\n\n.ops-vendor-chip {\n  width: 100%;\n  text-align: left;\n  padding: 7px 10px;\n  border-radius: 8px;\n  border: 1px solid #eef0f3;\n  background: #fff;\n  font-size: 12.5px;\n  color: #374151;\n  cursor: pointer;\n}\n\n.ops-vendor-chip--active {\n  background: #2563eb;\n  border-color: #2563eb;\n  color: #fff;\n}\n\n.ops-panel__chart--pie {\n  padding-top: 4px;\n}\n\n.ops-panel__footer-link {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 11.5px;\n  color: #9ca3af;\n  border-top: 1px solid #f1f2f4;\n  padding-top: 12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
